<template>
    <transition name="slide-fade">
        <div class="section col_w_3">
            <div class="section_wrap row">
                <div class="patient_info_wrap">
                    <div class="info_item_1">
                        <div class="item_1_tit no-drag">
                            <h6 class="--blue70"
                                style="overflow: hidden; text-overflow: ellipsis; display: block; white-space: nowrap; margin: 5px;">
                                {{patientTotalInfo.patientInfo.patientInfoName}}
                            </h6>
                            <span class="i_memo" @click="$modal.show('private-note-modal')">
                                <img src="../../../../assets/images/icon_memo.png" style="filter: brightness(0.1)" alt="">
                                {{$t('private_note.remarks')}}
                            </span>
                        </div>
                        <PatientInfoKvTable :items="getDefaultPatientData"/>
                    </div>
                    <div class="info_item_2">
                        <div class="item_2_tit no-drag">
                          <h6 class="--blue70">{{ $t('patient.condition.condition') }}</h6>
                            <span class="info_date">
                                {{newPatientTotalInfo.patientStatus.createDatetime===""? '': $t('table.header.last_edited')}}
                                <label>
                                    {{newPatientTotalInfo.patientStatus.createDatetime==="" ? '' : moment(newPatientTotalInfo.patientStatus.createDatetime).locale($t('country')).format('ll')}}
                                </label>
                            </span>
                        </div>
                        <PatientCondition :patientTotalInfo="newPatientTotalInfo"/>
                    </div>
                </div>
            </div>
            <PrivateNoteModal :patientInfoProps="patientTotalInfo"/>
        </div>
    </transition>
</template>
<script>
    import { mapActions } from 'vuex'
    import PatientCondition from './patientCondition'
    import PatientInfoKvTable from '@/components/Table/kvTable';
    import  PrivateNoteModal from '@/components/modal/privateNote'
    import {_BRAIN_LESION_RANGE} from "@/components/Table/static";

    export default {
        name: 'HeadArea',
        props: [ 'patientTotalInfo' ],
        components: {
            PatientInfoKvTable, PatientCondition, PrivateNoteModal
        },
        data() {
            return {
                newPatientTotalInfo : this.patientTotalInfo
            }
        },
        methods: {
          ...mapActions([
            'changeIsOpenFloatMenu',
            'changeNavMenu',
          ]),
          openPrivateNoteModal: function () {
            this.changeIsOpenFloatMenu(true);
          },
        },
        computed: {
            getDefaultPatientData() {
              return [
                {
                  index: 0,
                  keyTitle: this.$t('patient.condition.primary_diagnosis'),
                  keyType: 'Default',
                  class: [],
                  parentClass: '',
                  keyRange: [],
                  values: this.patientTotalInfo.patientInfo.patientInfoPrimaryDiagnosis || '-'
                },
                {
                  index: 1,
                  keyTitle: this.$t('patient.condition.secondary_diagnosis'),
                  keyType: 'Default',
                  class: [],
                  keyRange: [],
                  values: this.patientTotalInfo.patientInfo.patientInfoSecondaryDiagnosis || '-'
                },
                {
                  index: 2,
                  keyTitle: this.$t('patient.condition.on_set_date'),
                  keyType: 'Default',
                  class: [],
                  keyRange: [],
                  values: this.patientTotalInfo.patientInfo.patientInfoOccurrenceDate ? this.moment(this.patientTotalInfo.patientInfo.patientInfoOccurrenceDate).locale(this.$t('country')).format('ll') : '-'
                },
                {
                  index: 3,
                  keyTitle: this.$t('patient.condition.brain_lesions'),
                  keyType: 'Default',
                  class: [],
                  keyRange: [],
                  values: this.$t(_BRAIN_LESION_RANGE[this.patientTotalInfo.patientInfo.patientInfoBrainLesion]?.trans)
                }
              ];
            },
            getNewPatientTotalInfo() {
                return this.$store.state.patientList
            }
        },
        watch: {
            patientTotalInfo: {
                deep: true,
                handler(newData) {
                    this.newPatientTotalInfo = newData;
                }
            },
            getNewPatientTotalInfo : {
                deep : true,
                handler(newVal) {
                   for(let i = 0; newVal.length > i; i++) {
                       if (newVal[i].seqPatient === this.patientTotalInfo.seqPatient) {
                           this.newPatientTotalInfo = newVal[i];
                       }
                   }
                }
            },
        }
    }

</script>
<style lang="scss">

</style>